import { Inject, Injectable } from "@angular/core";
import { ISwitchCompanyModalService } from "./i-switch-company-modal.service";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { SwitchCompanyModalComponent } from "./switch-company-modal.component";

@Injectable()
export class SwitchCompanyModalService implements ISwitchCompanyModalService {
	constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {
	}

	open(): void {
		this._modalService.open(SwitchCompanyModalComponent, {
			header: "Organisation wechseln",
			showHeader: true,
			closable: true,
			width: "500px",
			closeOnEscape: true,
			dismissableMask: true
		});
	}
}
